import { assign, setup } from 'xstate';

import type {
  BasicInfoFormValues,
  CurrentAddressFormValues,
  IdDocumentFormValues,
  SelfieFormValues,
} from './schemas';

export type PersonData = Partial<{
  basicInfo: BasicInfoFormValues;
  currentAddress: CurrentAddressFormValues;
}>;

type PersonFlowContext = PersonData &
  Partial<{
    idDocument: IdDocumentFormValues;
    selfie: SelfieFormValues;
  }>;

export type PersonFlowEvent =
  | { type: 'next' }
  | { type: 'back' }
  | { type: 'basicInfo.submitData'; values: BasicInfoFormValues }
  | { type: 'currentAddress.submitData'; values: CurrentAddressFormValues }
  | { type: 'idDocument.submitData'; values: IdDocumentFormValues }
  | { type: 'selfie.submitData'; values: SelfieFormValues };

export const personMachine = setup({
  types: {
    context: {} as Partial<PersonFlowContext>,
    events: {} as PersonFlowEvent,
  },
}).createMachine({
  id: 'personFlow',
  initial: 'start',
  context: {},
  states: {
    start: {
      on: {
        next: { target: 'basicInfo' },
      },
    },
    basicInfo: {
      on: {
        'basicInfo.submitData': {
          actions: assign({
            basicInfo: ({ event }) => event.values,
          }),
        },
        next: {
          target: 'currentAddress',
        },
      },
    },
    currentAddress: {
      on: {
        back: { target: 'basicInfo' },
        'currentAddress.submitData': {
          actions: assign({
            currentAddress: ({ event }) => event.values,
          }),
        },
        next: {
          target: 'idDocument',
        },
      },
    },
    idDocument: {
      on: {
        back: { target: 'currentAddress' },
        'idDocument.submitData': {
          actions: assign({
            idDocument: ({ event }) => event.values,
          }),
        },
        next: {
          target: 'selfie',
        },
      },
    },
    selfie: {
      on: {
        back: { target: 'idDocument' },
        'selfie.submitData': {
          actions: assign({
            selfie: ({ event }) => event.values,
          }),
        },
        next: {
          target: 'completed',
        },
      },
    },
    completed: {
      type: 'final',
    },
  },
});
